import { AtividadePlanejamento } from "./../../../../classes/AtividadePlanejamento";
import { TipoAplicacao } from "./../../../../classes/TipoAplicacao";
import { Atividade } from "./../../../../classes/Atividade";
import { Produto } from "./../../../../classes/Produto";
import { ItensAtividade } from "./../../../../classes/ItensAtividade";
import { EtapaService } from "./../../../../services/etapa.service";
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  SimpleChanges,
} from "@angular/core";
import { Cultura } from "src/app/classes/Cultura";
import { Etapa } from "src/app/classes/Etapa";
import { UiModalComponent } from "src/app/theme/shared/components/modal/ui-modal/ui-modal.component";
import { AtividadePlanejamentoService } from "src/app/services/atividade-planejamento.service";
import Swal from "sweetalert2";
import { CulturaService } from "src/app/services/cultura.service";
import { Planejamento } from "src/app/classes/Planejamento";
import { PlanejamentoService } from "src/app/services/planejamento.service";
import { Safra } from "src/app/classes/Safra";
import { CustomToastyService } from "src/app/theme/shared/components/toasty/custom-toasty.service";
import { Router } from "@angular/router";
import { GrupoOperacao } from "src/app/classes/GrupoOperacao";
import { ProcessoPlanejamento } from "src/app/classes/ProcessoPlanejamento";
import { ProcessoPlanejamentoService } from "src/app/services/processo-planejamento.service";
import { TranslateService } from "@ngx-translate/core";
import {
  ColumnModel,
  GroupSettingsModel,
  PageSettingsModel,
  RowDataBoundEventArgs,
  SelectionSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { FormsEtapaComponent } from "../forms-etapa/forms-etapa.component";
import { ListaDetalheComponent } from "../lista-detalhe/lista-detalhe.component";
import { AuxEtapa, DataGridEtapa } from "src/app/classes/auxiliar/AuxEtapa";
import { SyncGridComponent } from "src/app/components/shared-farm/sync-grid/sync-grid.component";
import { UtilsService } from "src/app/utils/utils.service";
import { v4 as uuidv4 } from "uuid";
import { Usuario } from "src/app/classes/Usuario";
import { StorageService } from "src/app/services/storage.service";
import { PermissaoUsuario } from "src/app/classes/PermissaoUsuario";
import { EmpresaService } from "src/app/services/empresa.service";

@Component({
  selector: "app-tab-lateral",
  templateUrl: "./tab-lateral.component.html",
  styleUrls: ["./tab-lateral.component.scss"],
})
export class TabLateralComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() isDetalhe: Boolean = false;
  @Input() carregando: boolean = false;
  @Input() culturas: Cultura[];
  @Input() planejamento: Planejamento;
  @Input() custoTotalPlanejamento: number = 0;
  @Output() changeCultura: EventEmitter<Cultura> = new EventEmitter();
  @Output() custoTotalPlanejamentoAgrupado: EventEmitter<number> =
    new EventEmitter();

  @Input() etapas: Etapa[];
  @Output() changeEtapa: EventEmitter<Etapa> = new EventEmitter();
  @Output() insereEtapa: EventEmitter<Etapa> = new EventEmitter();
  @Output() excluiEtapa: EventEmitter<Etapa> = new EventEmitter();
  @Output() attListEtapas: EventEmitter<any> = new EventEmitter();
  @Output() changeAtividadeSalva: EventEmitter<AtividadePlanejamento> =
    new EventEmitter();
  @Output() atualizarPlanejamento: EventEmitter<any> =   new EventEmitter();

  @Input() safraSelecionada: Safra;

  @Input() visualizacaoAgrupada: boolean = false;
  @Input() atividades: Atividade[];
  @Input() gruposOperacao: GrupoOperacao[];
  @Input() itensAtividades: ItensAtividade[];
  @Input() tiposAplicacoes: TipoAplicacao[];
  @Input() atividadesPlanejamento: AtividadePlanejamento[];
  @Input() produtos: Produto[];
  @Input() sementes: Produto[];
  @Input() servicos: Produto[];
  @Input() apenasSimulacao: boolean = false;
  @Input() processosPlanejamento: ProcessoPlanejamento[];

  @ViewChild("gridEtapa", { static: false }) gridEtapa: SyncGridComponent;
  culturaSelecionada: Cultura;
  etapaSelecionada: Etapa;
  etapaEditando: Etapa;
  etapasAdicionadas: Etapa[] = [];
  etapasCadastradas: Etapa[] = [];

  filtroCultura: string = "";
  @Input() auxCulturas: Cultura[];
  etapaEditada: number = 0;
  etapaModal: any = "";
  dapModal: number = 0;
  EstadioFenologicoModalId: number = 0;
  processoPlanejamentoId: number = 0;
  ReferenciaDAPSelect: number = 0;
  custoEtapa = new Map<number, number>();
  custoProcesso = new Map<number, number>();
  processosExistentes: number[] = [];
  processoPlanejamentoSelecionado: ProcessoPlanejamento;
  salvando: boolean = false;
  auxEtapas: AuxEtapa[] = [];
  dataGrid: DataGridEtapa[] = [];
  semItems: string = "- Sem itens";
  gridHeightVhExecutado = false;
  usuario: Usuario;
  permissoes: PermissaoUsuario
  public simulando: boolean;

  public isSubmit: boolean;

  precisaoDose: number = 3

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 50, 1000],
    pageSize: 10000,
    pageCount: 4,
  };

  columnsEtapa: ColumnModel[] = [
    {
      field: "DAPSort",
      headerText: "",
      visible: false, // não mostra
      showInColumnChooser: false,
      isPrimaryKey: false,
      allowGrouping: false,
      allowSorting: true,
    },
    {
      field: "DAP",
      headerText: "DAP",
      width: 80,
      sortComparer: (a, b) => {
        const rowA = this.dataGrid.find((r) => r.DAP === a);
        const rowB = this.dataGrid.find((r) => r.DAP === b);
        if (!rowA || !rowB) return 0;
        return rowA.DAPSort - rowB.DAPSort;
      },
    },
    { field: "Etapa", headerText: "Etapa", width: 150, },
    { field: "GrupoOperacaoDesc", headerText: "Grupo Operação", width: 150 },
    {
      field: "OperacaoAgricolaDesc",
      headerText: "Operação Agrícola",
      width: 200,
    },
    { field: "GrupoProdutoDesc", headerText: "Grupo do Produto", width: 170 },
    { field: "ProdutoDesc", headerText: "Produto", width: 150 },
    { field: "Dose", headerText: "Dose/ha", width: 140 },
    {
      field: "PrecoUnitario",
      headerText: "Preço Unitário",
      width: 100,
      valueAccessor: (_field: string, _data: DataGridEtapa): any => {
        return `R$ ${this.utils.formatarDecimais(_data.PrecoUnitario)}`;
      },
    },
    {
      field: "",
      headerText: "Custo/ha",
      width: 100,
      valueAccessor: (_field: string, _data: DataGridEtapa): any => {
        return `R$ ${this.utils.formatarDecimais(_data.Custo || 0)}`;
      },
    },
  ];

  groupSettingsEtapa: GroupSettingsModel = {
    columns: ["DAP"],
  };
  gridEtapaShow = false;
  divHeight: number = 100;
  onDataBound: Function = () => {this.adicionarFuncaoDbClick()}
  @ViewChild("FormsEtapa", { static: false })
  FormsEtapa: FormsEtapaComponent;

  constructor(
    private culturaService: CulturaService,
    private router: Router,
    private etapaService: EtapaService,
    private toasty: CustomToastyService,
    private utils: UtilsService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private empresaService: EmpresaService,

  ) {
  }
  ngAfterViewInit(): void {
    this.getDivHeight();
  }

  ngOnInit() {
    // this.etapasAdicionadas = [];
    if (!this.isDetalhe) {
      this.culturaSelecionada =
        this.culturaService.culturaSelecionada == null
          ? this.culturas != null && this.culturas.length > 0
            ? this.culturas[0]
            : null
          : this.culturaService.culturaSelecionada;
      this.selecionarCultura(this.culturaSelecionada);
    }

    const empresa = this.storageService.getEmpresa()
    this.empresaService.getEmpresa(empresa.Id).subscribe((res) => {
      this.precisaoDose = res.CasasDecimaisDose
    })

    // if (this.isDetalhe) {
    //   this.etapaService.getEtapas().subscribe(
    //     ret => {
    //       this.etapasCadastradas = ret;
    //     });
    // }
  }

  getGridHeightVh() {
      if(!this.gridHeightVhExecutado)
      setTimeout(() => {
        var headerGrid = document.querySelector('div.e-groupdroparea.e-grouped.e-lib.e-droppable.e-draggable') as HTMLElement
        var groupSection = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
        this.divHeight = this.divHeight - headerGrid.offsetHeight - groupSection.offsetHeight - 30
        this.gridHeightVhExecutado = true
      }, 500);
  }

  getDivHeight(): void {
    setTimeout(() => {
    var navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    var divTitulo = document.querySelector('div.page-bloc.div-titulo-planejamento') as HTMLElement
    var divNav = document.querySelector('div.nav-planejamento.filter-bar') as HTMLElement
    var pageHeight = window.innerHeight
    this.divHeight = pageHeight - navbar.offsetHeight - divTitulo.offsetHeight - divNav.offsetHeight - 30
    var container = document.querySelector('.container-planejamento') as HTMLElement
    container.style.height = (window.innerHeight - navbar.offsetHeight - 10) + 'px'

    // var navigation = document.querySelector('app-navigation') as HTMLElement
    // navigation.style.height = container.style.height
    }, 1000);
  }

  novaEtapa() {
    this.FormsEtapa.openModal(this.planejamento.Id);
  }

  editarAuxEtapa(dataGridEtapa: DataGridEtapa) {
    dataGridEtapa.AuxEtapa.ItensAtividade =
      dataGridEtapa.AuxEtapa.ItensAtividade.filter((p) => !p.fakeItem);
    this.FormsEtapa.openEditModal(dataGridEtapa.AuxEtapa);
  }

  filtrarCulturas() {
    this.culturas = this.auxCulturas.filter((x) =>
      x.Descricao.toUpperCase().includes(this.filtroCultura.toUpperCase())
    );
  }
  finalizarCriacaoEtapas() : void{
    this.listarAuxEtapas();
    this.atualizarPlanejamento.emit();
  }
  listarAuxEtapas() {
    this.carregando = true
    this.etapaService.getAuxEtapas(this.planejamento.Id).subscribe(
      (ret) => {
        this.dataGrid = [];
        this.auxEtapas = ret;
        console.log(this.auxEtapas);
        this.auxEtapas.forEach((x) => {
          if (x.ItensAtividade.length <= 0) {
            var fakeItem = new ItensAtividade();
            fakeItem.fakeItem = true;
            x.ItensAtividade.push(fakeItem);
          }
          x.ReferenciaDAP;
          let valorOrdenacao =
            x.ReferenciaDAP === 0 ? -x.DiasAposPlantio : x.DiasAposPlantio;
          x.ItensAtividade.forEach((a) => {
            this.dataGrid.push({
              EtapaId: x.Id,
              DAP: `${valorOrdenacao} | ${x.Descricao} #${x.Id}`,
              DAPSort: valorOrdenacao,
              Etapa: x.Descricao,
              IsFake: a.fakeItem,
              GrupoOperacaoDesc: x.GrupoOperacaoDescricao,
              OperacaoAgricolaDesc: x.OperacaoAgricolaDescricao,
              ProdutoDesc: a.NomeProduto,
              GrupoProdutoDesc: a.NomeGrupoProduto,
              Dose: a.Dose.toLocaleString('pt-BR', { minimumFractionDigits: this.precisaoDose, maximumFractionDigits: this.precisaoDose }),
              PrecoUnitario: a.PrecoUnitario,
              DesprezarNoCusto: a.DesprezarNoCusto,
              ProdutoId: a.ProdutoId,
              AuxEtapa: x,
              Custo : a.Custo
            });
          });
        });
        console.log(this.dataGrid);
        this.carregando = false
        this.gridEtapaShow = true;
      this.getGridHeightVh()
      },
      (error) => {
        this.utils.getErro(error);
        this.carregando = false
        this.gridEtapaShow = true;
      }
    );
  }

  // calcularCustoTotalPlanejamento(){
  //   var custoTotal = 0;
  //   this.dataGrid.forEach(p =>{
  //     if(p.ProdutoId && !p.DesprezarNoCusto)
  //       custoTotal += p.PrecoUnitario * p.Dose;
  //   })
  //   this.changeCusto(custoTotal)
  // }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["planejamento"] &&
      this.planejamento.Id &&
      this.auxEtapas.length == 0
    ) {
      this.listarAuxEtapas();
    }

    this.etapasAdicionadas = [];
    if (!this.isDetalhe) {
      this.culturaSelecionada =
        this.culturaService.culturaSelecionada == null
          ? this.culturas != null && this.culturas.length > 0
            ? this.culturas[0]
            : null
          : this.culturaService.culturaSelecionada;
      this.selecionarCultura(this.culturaSelecionada);
    }
  }

  selecionarCultura(cultura: Cultura) {
    this.culturaSelecionada = cultura;
    this.culturaService.culturaSelecionada = cultura;
    this.changeCultura.emit(cultura);
  }


  changeCusto(custo: number) {
    if (custo) {
      this.custoTotalPlanejamento = custo;
      this.custoTotalPlanejamentoAgrupado.emit(custo);
    }
  }


  doubleClickGrid(event) {}
  ungrouping(args) : void{
    if(args.columnName == 'DAP')
      this.dataGrid.forEach(p => {
       p.DAP = p.DAPSort.toString()
      })
  }
  grouping(args): void{
    if(args.columnName == 'DAP')
      this.dataGrid.forEach(p => {
        p.DAP = `${p.DAPSort} | ${p.Etapa} #${p.EtapaId}`
      })
  }
  onRowDataBound(args: RowDataBoundEventArgs) {
    if (args.data["IsFake"] === true) {
      var row = args.row as HTMLTableRowElement;
      row.style.visibility = "hidden";
      row.style.display = "none";
    }
  }

  adicionarFuncaoDbClick(): void{
    setTimeout(() => {
      // Seleciona todas as linhas de agrupamento
      const groupRows = document.querySelectorAll(".e-groupcaption");

      // Verifica se há elementos de agrupamento antes de processar
      if (groupRows.length === 0) {
        console.debug('Nenhum elemento de agrupamento encontrado');
        return;
      }

      const colunasAgrupadas = this.gridEtapa.grid.groupSettings.columns;
      const agrupadoPorDAP = colunasAgrupadas.includes('DAP');

      groupRows.forEach((row) => {
        let texto = row.textContent || "";
        if (texto.includes(this.semItems)) {
          texto = texto.replace(/- 1 item$/, "").trim();
        }

        texto = texto.replace(/\s*-\s*\d+\s+itens?/gi, '').trim();

        texto = texto.replace(/\s*-\s*\d+\s+item?/gi, '').trim();

        const groupText = row.textContent.trim();
        if (!groupText) return;
        const idMatch = groupText.match(/#(\d+)/);
        if(idMatch)
          texto = texto.replace(idMatch[0], "").trim();

        // Captura o ID após o '#'
        const id = idMatch ? idMatch[1] : null;

        // Verifica se o evento já foi adicionado para evitar duplicação
        if (!row.getAttribute("data-dblclick-event")) {
          row.setAttribute("data-dblclick-event", "true"); // Marca que já foi tratado
          row.addEventListener("dblclick", (event) =>
            this.onGroupTitleDoubleClick(event, id)
          );
        }

        if (!agrupadoPorDAP)
          texto = texto.split('|')[0].trim()

        row.classList.add("pl-3");
        row.classList.add("bg-c-group");
        row.innerHTML = `
          <div class="d-flex justify-content-between" >
            <span>${texto}</span>
            <i class="icon feather icon-edit f-16 text-c-green mr-3"></i>
          </div>
          `;

          const editIcon = row.querySelector(".icon-edit");
          if (editIcon) {
            editIcon.addEventListener("click", () =>
              this.onGroupTitleDoubleClick(event, id)
            );
          }
      });

      // Só executa groupCollapseAll se houver elementos de agrupamento
      if (groupRows.length > 0) {
        this.gridEtapa.groupCollapseAll();
      }

    }, 100); // Pequeno delay para garantir que os elementos já renderizaram
  }
  onGroupTitleDoubleClick(event: Event, id: string) {
    if (!id) return;

    if (!this.dataGrid.length) {
      return;
    }

    // Filtra os itens com base no ID extraído
    const items = this.dataGrid.filter(
      (item) => item.EtapaId.toString() === id
    );

    if (items.length > 0) {
      const firstItem = items[0]; // Obtém o primeiro item do grupo
      var copiaObj = this.utils.deepCopy(firstItem.AuxEtapa);
      copiaObj.ItensAtividade = copiaObj.ItensAtividade.filter(
        (p) => !p.fakeItem
      );
      this.FormsEtapa.openEditModal(copiaObj);
    } else {
      console.log("Nenhum item encontrado para o ID:", id);
    }
  }

}
